import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import axios from '@/axios';
import store from '@/store';

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [

  {
    path: '/',
    component: () => import('@/layouts/Default.vue'),
    children: [
      {
        path: '',
        name: 'Home',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: HomeView
      },
      {
        path: 'collection/:id',
        name: 'Collection',
        component: HomeView
      },
    ],
  },
  {
    // Public share links. No account needed, so these sit outside the
    // authenticated layout and are exempted from the login guard below.
    path: '/s/:token',
    component: () => import('@/layouts/Public.vue'),
    meta: { public: true },
    children: [
      {
        path: '',
        name: 'Share',
        component: () => import('@/views/ShareView.vue'),
        meta: { public: true },
      },
      {
        path: ':id',
        name: 'ShareCollection',
        component: () => import('@/views/ShareView.vue'),
        meta: { public: true },
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('@/layouts/Login.vue'),
  },
]

const isPublic = (route: any) => route.matched.some((r: any) => r.meta && r.meta.public);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  // A share link must open for someone with no account, so don't ask the API
  // who they are and don't send them to the login page.
  if (isPublic(to)) {
    next();
    return;
  }

  if (store.state.isLoggedIn === null) {
    const response = await axios.get('/api/auth/isLoggedIn');
    if (response.data.isLoggedIn) {
      store.state.isLoggedIn = true;
    } else {
      store.state.isLoggedIn = false;
    }
  }

  if (store.state.isLoggedIn === false && to.name !== 'Login') {
    next({ name: 'Login' });
    return;
  }
  next()
})

router.beforeEach(async (to, from, next) => {
  if (store.state.isLoggedIn === true && to.name === 'Login') {
    next({ name: 'Home' });
    return;
  }
  next()
});



export default router
